/**
 * Dirty-file tracking for git workspace external change conflicts.
 */

/** @type {Map<string, Set<string>>} workspaceRoot -> dirty relative paths */
const dirtyFiles = new Map();

export function markDirty(rootPath, relativePath) {
  const root = normalizeRoot(rootPath);
  if (!dirtyFiles.has(root)) dirtyFiles.set(root, new Set());
  dirtyFiles.get(root).add(normalizeRel(relativePath));
}

export function clearDirty(rootPath, relativePath) {
  const root = normalizeRoot(rootPath);
  dirtyFiles.get(root)?.delete(normalizeRel(relativePath));
}

export function isDirty(rootPath, relativePath) {
  const root = normalizeRoot(rootPath);
  return dirtyFiles.get(root)?.has(normalizeRel(relativePath)) ?? false;
}

export function clearAllDirty(rootPath) {
  dirtyFiles.delete(normalizeRoot(rootPath));
}

function normalizeRoot(p) {
  return String(p || '').replace(/\\/g, '/').replace(/\/+$/, '');
}

function normalizeRel(p) {
  return String(p || '').replace(/\\/g, '/').replace(/^\.\//, '');
}

export function resolveConflictAction(action) {
  return action === 'keep' || action === 'reload' ? action : 'keep';
}
